import * as React from "react";

// Glifo sólido que hereda el color del contenedor. Antes era el mismo dibujo
// pero trazado con un borde de 1.5px, que a 17px dentro del campo se veía
// como una mancha, y con el azul escrito a mano adentro del path.
const LinkedinLineIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9.5h4v11H3v-11ZM9.5 9.5h3.83v1.5h.05c.53-.95 1.83-1.95 3.77-1.95 4.03 0 4.78 2.5 4.78 5.75v6.2h-4v-5.5c0-1.31-.02-3-1.9-3-1.9 0-2.2 1.42-2.2 2.9v5.6h-4v-11Z" />
  </svg>
);

export default LinkedinLineIcon;
